import { UserToken } from "../../models/UserToken";
import { Action } from "../../models/Action";
import { getUserDataByToken, login, logOut, setFakeSession, setUserToken } from "./authActions";
import { WebUser } from "../../models/WebUser";

export interface AuthState {
  isLoggedIn: boolean;
  userToken: UserToken;
  loading: boolean;
  userData: WebUser;
}

const initialAuth: AuthState = {
  isLoggedIn: false,
  loading: false,
  userToken: {} as UserToken,
  userData: {} as WebUser,
};

export default function authReducer(authState = initialAuth, action: Action<any>) {
  switch (action.type) {
    case login.pending.toString():
      return { ...authState, loading: true };
    case login.rejected.toString():
      return {
        ...authState,
        loading: false,
        isLoggedIn: false,
      };
    case setUserToken.toString():
      return {
        ...authState,
        loading: false,
        isLoggedIn: true,
        userToken: action.payload,
      };
    case getUserDataByToken.pending.toString():
      return { ...authState, loading: true };
    case getUserDataByToken.fulfilled.toString():
      return {
        ...authState,
        userData: action.payload,
        loading: false,
      };
    case getUserDataByToken.rejected.toString():
      return initialAuth;
    case logOut.toString():
      return initialAuth;
    case setFakeSession.toString():
      return {
        ...authState,
        loading: false,
        isLoggedIn: false,
        userToken: action.payload,
      };
    default:
      return authState;
  }
}
